import { filterMaybeArray } from "@examspark/common";
import { Maybe, ResourceContent, Objective, Resource } from "@examspark/types";

export const parseItemCanvas = <
  T extends { content?: Maybe<{ canvas?: Maybe<ResourceContent["canvas"]> }> },
>(
  draft: Maybe<T> | undefined,
) => {
  if (draft?.content?.canvas) {
    draft.content.canvas.forEach((el) => {
      if (typeof el?.config === "string") el.config = JSON.parse(el.config);
      if (typeof el?.content === "string") el.content = JSON.parse(el.content);
      if (typeof el?.scoring === "string") el.scoring = JSON.parse(el.scoring);
    });
  }
};

export const schemaParams = () => {
  return {
    schemaVersion: "2020-01-01",
  };
};

export const timestampParams = () => {
  return {
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
};

/**
 * We've got a pervasive disagreement between graphql and typescript about the
 * type of the `alignments` field. Typescript does not expect `.items` to exist,
 * when data returned really does contain it. This function can normalize use of
 * this field so we can one day mass-update the types/api.
 *
 * Dev Note: Using two copies of this code: one for contexts, one for alignments.
 * These are the only two issues like this that exist and this allows us to
 * refactor a set of issues one method at a time.
 */
export const getAlignmentsSafely = (
  data?:
    | Maybe<Maybe<Objective>[]>
    | {
        items: Maybe<Maybe<Objective>[]>;
      },
): Objective[] => {
  if (!data) return [];
  if (Array.isArray(data)) return filterMaybeArray(data);
  if (data.items) return filterMaybeArray(data.items);
  return [];
};

/**
 * We've got a pervasive disagreement between graphql and typescript about the
 * type of the `contexts` field. Typescript does not expect `.items` to exist,
 * when data returned really does contain it. This function can normalize use of
 * this field so we can one day mass-update the types/api.
 *
 * Dev Note: Using two copies of this code: one for contexts, one for alignments.
 * These are the only two issues like this that exist and this allows us to
 * refactor a set of issues one method at a time.
 */
export const getContextsSafely = (
  data?:
    | Maybe<Maybe<Resource>[]>
    | {
        items: Maybe<Maybe<Resource>[]>;
      },
) => {
  if (!data) return [];
  if (Array.isArray(data)) return filterMaybeArray(data);
  if (data.items) return filterMaybeArray(data.items);
  return [];
};
